import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useRef } from "react";
import { usePrevious } from "__barrel_optimize__?names=usePrevious!=!react-use";
import { NEW_DISCUSSION_ID } from "~/components/Annotations/shared/useActiveDiscussionIdObserver";
import { DiscussionsLoadMoreItem } from "~/components/Discussions/components/DiscussionsLoadMoreItem";
import { DiscussionsVirtualizedList } from "~/components/Discussions/components/DiscussionsVirtualizedList";
import { ClipDiscussion, DiscussionSkeleton } from "~/components/Discussions/Discussion/ClipDiscussion";
import { DISCUSSIONS_LIST } from "~/constants/testIDs";
export const DiscussionsList = /*#__PURE__*/ memo((param)=>{
    let { discussions, canReply = true, isLoading, onCommentDelete, onCommentEdit, onToggleCommentResolve, onCommentSubmit, mentionsList, onSwitchVersion, shouldShowMentionsButton, onAnnotatedCommentClick, emptyState, hasNextPage, fetchNextPage, totalDiscussions } = param;
    const listRef = useRef(null);
    const previousDiscussionsTotal = usePrevious(totalDiscussions);
    useEffect(()=>{
        if (previousDiscussionsTotal && totalDiscussions > previousDiscussionsTotal) {
            var _listRef_current;
            (_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.scrollToBottom();
        }
    }, [
        previousDiscussionsTotal,
        totalDiscussions
    ]);
    const renderComments = useCallback((param)=>{
        let { index } = param;
        if (hasNextPage && index === 0) {
            var _listRef_current;
            return /*#__PURE__*/ _jsx(DiscussionsLoadMoreItem, {
                scrollElementRef: (_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.getScrollElement(),
                isLoading: isLoading,
                loadMore: fetchNextPage
            });
        } else {
            const itemIndex = hasNextPage ? index : index + 1;
            const discussion = discussions[discussions.length - itemIndex];
            return /*#__PURE__*/ _jsx(ClipDiscussion, {
                discussion: discussion,
                clipId: discussion.clipId,
                mentionsList: mentionsList,
                canReply: canReply,
                onDelete: onCommentDelete,
                onEdit: onCommentEdit,
                onToggleResolve: onToggleCommentResolve,
                onSubmit: onCommentSubmit,
                onSwitchVersion: onSwitchVersion,
                shouldShowMentionsButton: shouldShowMentionsButton,
                onAnnotatedCommentClick: onAnnotatedCommentClick
            }, discussion.id === NEW_DISCUSSION_ID ? "".concat(discussion.id, "-").concat(index) : discussion.id);
        }
    }, [
        canReply,
        discussions,
        fetchNextPage,
        hasNextPage,
        isLoading,
        mentionsList,
        onAnnotatedCommentClick,
        onCommentDelete,
        onCommentEdit,
        onCommentSubmit,
        onSwitchVersion,
        onToggleCommentResolve,
        shouldShowMentionsButton
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex h-full overflow-y-auto",
        children: /*#__PURE__*/ _jsx("div", {
            className: "relative flex max-h-full w-full flex-1",
            "data-testid": DISCUSSIONS_LIST,
            children: isLoading && !discussions.length ? /*#__PURE__*/ _jsxs("div", {
                className: "flex size-full flex-col justify-end px-5",
                children: [
                    /*#__PURE__*/ _jsx(DiscussionSkeleton, {}),
                    /*#__PURE__*/ _jsx(DiscussionSkeleton, {})
                ]
            }) : !!(discussions === null || discussions === void 0 ? void 0 : discussions.length) ? /*#__PURE__*/ _jsx(DiscussionsVirtualizedList, {
                ref: listRef,
                itemsCount: hasNextPage ? discussions.length + 1 : discussions.length,
                children: renderComments
            }) : emptyState
        })
    });
});
DiscussionsList.displayName = "DiscussionsList";
